import styled from 'styled-components'

export const ConversationOrderSummaryPriceStyled = styled.span`
  justify-self: end;
  white-space: nowrap;
  font-weight: ${(props) => props.theme.fontWeights.semibold};
`
